import type { Dictionary } from "./translations";

export const ko: Dictionary = {
  "meta.title": "AgentBuck - AI 모델 가격 비교",
  "meta.description": "주요 AI 모델의 API 가격을 비교하고 실제 토큰 사용량을 기준으로 월간 비용을 계산하세요.",
  "nav.prices": "모델 가격",
  "nav.calculator": "비용 계산기",
  "nav.providers": "제공업체",
  "nav.guide": "가격 가이드",
  "nav.method": "산정 방법",
  "aria.home": "AgentBuck 홈",
  "aria.language": "언어 선택",
  "aria.navigation": "주 탐색",
  "aria.breadcrumb": "현재 위치",
  "aria.dark": "다크 모드로 전환",
  "aria.light": "라이트 모드로 전환",
  "title.dark": "다크 모드",
  "title.light": "라이트 모드",
  "hero.eyebrow": "AI API 가격 데이터베이스",
  "hero.title": "예산에 맞는 AI 모델을 찾아보세요",
  "hero.subtitle": "입력, 출력, 캐시 가격을 동일한 기준으로 비교하고 실제 토큰 사용량으로 월간 비용을 계산하세요.",
  "stats.models": "비교 가능한 모델",
  "stats.providers": "주요 제공업체",
  "stats.updated": "데이터 갱신일",
  "common.loading": "불러오는 중",
  "notice.snapshot": "실시간 데이터를 사용할 수 없습니다. 2026년 9월 7일의 내장 스냅샷을 표시합니다.",
  "common.retry": "다시 시도",
  "common.home": "홈",
  "common.models": "모델",
  "common.providers": "제공업체",
  "common.from": "최저",
  "common.viewAll": "모두 보기",
  "common.backPricing": "가격표로 돌아가기",
  "share.quick": "이 페이지 공유",
  "share.kicker": "팀과 공유",
  "share.title": "이 비교 공유",
  "share.description": "선택한 모델과 사용량 조건을 그대로 포함한 페이지를 공유하세요.",
  "share.copy": "링크 복사",
  "share.copied": "링크 복사됨",
  "share.more": "공유",
  "share.openComparison": "공유 페이지 열기",
  "share.email": "이메일",
  "calculator.title": "월간 비용 계산기",
  "calculator.input": "월간 입력",
  "calculator.output": "월간 출력",
  "calculator.cache": "캐시 입력 비율",
  "calculator.million": "백만 토큰",
  "calculator.cheapest": "현재 비용이 가장 낮은 모델 5개",
  "calculator.perMonth": "예상 / 월",
  "prices.title": "모델 가격",
  "prices.subtitle": "표준 실시간 API, 백만 토큰당 USD",
  "filter.open": "필터",
  "filter.search": "모델 또는 제공업체 검색",
  "filter.clearSearch": "검색 지우기",
  "filter.provider": "제공업체별 필터",
  "filter.allProviders": "모든 제공업체",
  "filter.sort": "모델 정렬",
  "filter.favorite": "저장됨",
  "sort.monthly": "예상 월간 비용",
  "sort.input": "입력 가격",
  "sort.output": "출력 가격",
  "sort.context": "컨텍스트 창",
  "sort.newest": "최신 출시순",
  "cap.reasoning": "추론",
  "cap.tools": "도구 호출",
  "cap.vision": "비전",
  "cap.structured": "구조화된 출력",
  "cap.openWeights": "공개 가중치",
  "results.found": "모델 {count}개 검색됨",
  "results.source": "공개된 가격을 동일한 기준으로 환산했습니다. 제공업체 문서에서 확인하세요.",
  "column.compare": "비교",
  "column.model": "모델 / 제공업체",
  "column.input": "입력",
  "column.cached": "캐시 입력",
  "column.output": "출력",
  "column.monthly": "예상 월간 비용",
  "column.context": "컨텍스트",
  "column.capabilities": "추론  도구  비전",
  "column.actions": "작업",
  "action.officialDocs": "공식 문서",
  "action.addCompare": "비교에 추가",
  "action.removeCompare": "비교에서 제거",
  "action.addFavorite": "모델 저장",
  "action.removeFavorite": "저장 취소",
  "action.added": "추가됨",
  "context.suffix": "컨텍스트",
  "empty.title": "일치하는 모델이 없습니다",
  "empty.description": "다른 검색어를 사용하거나 기능 필터를 해제하세요.",
  "empty.clear": "필터 지우기",
  "home.exploreKicker": "카탈로그 탐색",
  "home.exploreTitle": "AI 모델을 비교하는 더 많은 방법",
  "home.providersTitle": "제공업체별 탐색",
  "home.providersBody": "OpenAI, Anthropic, Google, DeepSeek, Alibaba 등 지원되는 제공업체의 모든 모델을 비교하세요.",
  "home.guideTitle": "가격 가이드 읽기",
  "home.guideBody": "토큰 비율, 프롬프트 캐싱, 컨텍스트 구간별 요금 등 최종 API 청구액에 영향을 주는 요소를 알아보세요.",
  "home.open": "열기",
  "providers.kicker": "제공업체 목록",
  "providers.title": "AI 모델 제공업체",
  "providers.intro": "AgentBuck 카탈로그에 있는 주요 제공업체의 API 가격, 컨텍스트 한도, 기능을 동일한 기준으로 확인하세요.",
  "providers.models": "모델 {count}개",
  "providers.starting": "최저 입력 요금",
  "providers.view": "제공업체 보기",
  "provider.kicker": "제공업체 가격",
  "provider.titleSuffix": "API 가격",
  "provider.description": "{name} 모델 {count}개를 입력 가격, 출력 가격, 컨텍스트 창, 운영에 필요한 기능으로 비교하세요.",
  "provider.cheapest": "최저 입력 가격",
  "provider.largestContext": "최대 컨텍스트",
  "provider.updated": "카탈로그 갱신일",
  "model.kicker": "모델 가격 상세",
  "model.title": "{name} API 가격",
  "model.descriptionFallback": "이 모델의 API 토큰 요금, 컨텍스트 한도, 기능, 예상 월간 비용을 비교하세요.",
  "model.input": "입력 / 백만 토큰",
  "model.cache": "캐시 입력 / 백만 토큰",
  "model.output": "출력 / 백만 토큰",
  "model.context": "컨텍스트 창",
  "model.maxOutput": "최대 출력",
  "model.released": "출시일",
  "model.updated": "모델 갱신일",
  "model.estimateTitle": "월간 비용 예상치",
  "model.estimateBody": "입력 {input}백만 토큰, 출력 {output}백만 토큰, 캐시 입력 {cache}% 기준입니다.",
  "model.relatedTitle": "{provider}의 다른 모델",
  "compare.pageTitle": "공유된 AI 모델 비용 비교",
  "compare.pageBody": "이 URL에 저장된 조건으로 토큰 요금, 컨텍스트 창, 기능, 월간 비용을 비교하세요.",
  "compare.emptyTitle": "비교할 모델이 없습니다",
  "compare.emptyBody": "가격표에서 모델 두세 개를 선택하여 공유 가능한 비교를 만드세요.",
  "compare.start": "모델 선택",
  "compare.usage": "공유된 작업량",
  "notFound.title": "페이지를 찾을 수 없습니다",
  "notFound.body": "페이지가 이동되었거나 해당 모델이 현재 카탈로그에서 제거되었을 수 있습니다.",
  "guide.kicker": "실용적인 구매 가이드",
  "guide.title": "실제 작업량에 맞춰 AI API 가격을 비교하세요",
  "guide.intro": "입력 요금이 가장 낮다고 총 청구액도 가장 낮은 것은 아닙니다. AgentBuck은 프롬프트, 캐시된 프롬프트, 생성된 토큰 비용을 합산하여 GPT, Claude, Gemini, DeepSeek, Qwen, Grok 등을 동일한 작업량으로 비교합니다.",
  "guide.inputTitle": "토큰 비율부터 확인하세요",
  "guide.inputBody": "챗봇은 보통 출력보다 입력을 많이 사용합니다. 코딩 에이전트와 추론 시스템은 훨씬 많은 출력을 생성할 수 있어 가장 경제적인 모델이 달라집니다.",
  "guide.cacheTitle": "프롬프트 캐싱을 포함하세요",
  "guide.cacheBody": "반복되는 시스템 프롬프트와 긴 공유 컨텍스트에서는 캐시 읽기 요금이 결정적일 수 있습니다. 월간 총비용을 비교하기 전에 현실적인 캐시 비율을 설정하세요.",
  "guide.fitTitle": "기능과 컨텍스트를 확인하세요",
  "guide.fitBody": "모델이 필요한 컨텍스트 창, 시각 입력, 추론 수준, 구조화된 출력, 도구 호출을 지원해야 가격 비교가 의미 있습니다.",
  "faq.kicker": "자주 묻는 질문",
  "faq.title": "AI 모델 가격 FAQ",
  "faq.q1": "AgentBuck은 AI 모델 API 가격을 어떻게 비교하나요?",
  "faq.a1": "AgentBuck은 표준 실시간 API 요금을 백만 토큰당 미국 달러로 통일하고 입력, 캐시 입력, 출력 비용을 구분합니다. 확인을 위한 제공업체 문서 링크도 제공합니다.",
  "faq.q2": "어떤 AI 모델의 API가 가장 저렴한가요?",
  "faq.a2": "모든 상황에서 가장 저렴한 모델은 없습니다. 입력과 출력의 비율, 캐시 사용량, 필요한 기능에 따라 달라집니다. 위에 월간 사용량을 입력하면 작업량에 맞게 모델을 정렬할 수 있습니다.",
  "faq.q3": "LLM의 예상 월간 비용은 어떻게 계산하나요?",
  "faq.a3": "캐시되지 않은 입력, 캐시 입력, 출력 사용량에 각 모델의 해당 요금을 곱해 합산합니다. 세금, 배치 할인, 지역별 가격, 긴 컨텍스트 추가 요금은 제외됩니다.",
  "faq.q4": "모델 가격이 0달러로 표시되는 이유는 무엇인가요?",
  "faq.a4": "일부 제공업체는 특정 모델에 무료 또는 프로모션 이용을 제공합니다. 이용 가능 여부와 한도는 바뀔 수 있으므로 운영 환경에서 사용하기 전에 연결된 문서를 확인하세요.",
  "faq.q5": "가격 데이터는 얼마나 자주 갱신되나요?",
  "faq.a5": "AgentBuck은 구조화된 가격 카탈로그를 6시간마다 갱신합니다. 모델 표에는 원본 데이터의 최신 모델 갱신일이 표시되며 실제 청구에는 제공업체 약관이 적용됩니다.",
  "method.title": "데이터 및 산정 방법",
  "method.priceTitle": "가격 기준",
  "method.priceBody": "표준 실시간 API의 백만 토큰당 USD 가격입니다. 세금, 배치 요금, 지역별 추가 요금, 긴 컨텍스트 구간별 요금은 제외됩니다.",
  "method.sourceTitle": "데이터 출처",
  "method.sourceBefore": "공개 모델 카탈로그와 제공업체 가격 페이지를 비교 가능한 데이터셋으로 정규화합니다.",
  "method.sourceAfter": "AgentBuck은 6시간마다 갱신하며 확인을 위한 제공업체 문서 링크를 제공합니다.",
  "method.costTitle": "비용 추정",
  "method.costBody": "월간 비용 = 일반 입력 + 캐시 입력 + 출력입니다. 예산 계획에 활용하세요. 실제 청구액의 기준은 제공업체 대시보드입니다.",
  "footer.tagline": "모든 토큰을 가치 있게.",
  "footer.updated": "데이터 갱신: {date}",
  "compare.selected": "{count}/3개 선택",
  "compare.remove": "{name} 제거",
  "compare.button": "모델 비교",
  "compare.kicker": "모델 비교",
  "compare.title": "가격과 기능을 나란히 비교하세요",
  "compare.close": "닫기",
  "compare.input": "입력 / 백만 토큰",
  "compare.cache": "캐시 / 백만 토큰",
  "compare.output": "출력 / 백만 토큰",
  "compare.monthly": "예상 월간 비용",
  "compare.context": "컨텍스트",
  "compare.capabilities": "추론 / 도구 / 비전",
  "compare.docs": "제공업체 문서",
  "compare.viewPrice": "가격 보기",
  "nav.requestCalculator": "요청 비용 계산기",
  "home.calculatorTitle": "요청량 기준 비용 추정",
  "home.calculatorBody": "일일 요청 수, 요청당 토큰 수, 캐시 적중률을 기준으로 월간 지출을 계산합니다.",
  "home.compareDirectoryTitle": "모델 비교 둘러보기",
  "home.compareDirectoryBody": "엄선된 비교로 시작하거나 가격표에서 직접 비교를 만들어 보세요.",
  "model.formulaTitle": "비용 계산 공식",
  "model.formulaBody": "월간 비용 = (캐시되지 않은 입력 토큰 × 입력 단가) + (캐시된 입력 토큰 × 캐시 읽기 단가) + (출력 토큰 × 출력 단가), 모두 100만 토큰 기준입니다. 공개된 캐시 읽기 단가가 없으면 캐시 토큰은 표준 입력 단가로 추정합니다.",
  "model.exampleTitle": "재현 가능한 예시",
  "model.exampleBody": "예시: 입력 토큰 {inputM}개(그중 {cachePercent}%가 캐시)와 출력 토큰 {outputM}개는 이 모델의 공개 요금 기준으로 {total}입니다 — 100만 토큰당 입력 {inputRate}, 캐시 입력 {cacheRate}, 출력 {outputRate}.",
  "model.calculatorCta": "일일 요청량 기준 비용 추정",
  "model.comparisonsTitle": "다음 엄선된 비교에 포함됨",
};
